import BaseService from '@/services/BaseService'

class OrderService {

    constructor() {
        this._httpService = new BaseService();
    }

    getOrders() {
        let settings = {
            baseURL: `${this._httpService.baseUrl}/order-management/orders`,
            method: 'GET'
        }
        console.info('personOrders')
        return this._httpService.service(settings)
    }

    getOrder(orderId) {
        let settings = {
            baseURL: `${this._httpService.baseUrl}/order-management/orders/${orderId}`,
            method: 'GET'
        }
        console.info('personOrderDetail')
        return this._httpService.service(settings)
    }

    getOrderStorageCards(orderId) {
        let settings = {
            baseURL: `${this._httpService.baseUrl}/order-management/orders/${orderId}/storage-cards`,
            method: 'GET'
        }
        console.info('personOrderDetail')
        return this._httpService.service(settings)
    }

    getOrderCsv(orderId) {
        let settings = {
            baseURL: `${this._httpService.baseUrl}/order-management/orders/${orderId}/csv`,
            method: 'GET'
        }
        console.info('personOrderDetail')
        return this._httpService.service(settings)
    }

    putOrder(orderId, order) {
        let settings = {
            baseURL: `${this._httpService.baseUrl}/order-management/orders/${orderId}`,
            method: 'PUT',
            data: order
        }
        return this._httpService.service(settings)
    }

    postOptimization(board) {
        let settings = {
            baseURL: `${this._httpService.baseUrl}/customer-management/optimization`,
            method: 'POST',
            data: board
        }
        return this._httpService.service(settings)
    }

    postCuttingOrder(board) {
        let settings = {
            baseURL: `${this._httpService.baseUrl}/customer-management/orders`,
            method: 'POST',
            data: board
        }
        return this._httpService.service(settings)
    }

    getUnprocessedOrderDetails() {
        let settings = {
            baseURL: `${this._httpService.baseUrl}/order-management/order-details/unprocessed`,
            method: 'GET'
        }
        console.info('personOrders')
        return this._httpService.service(settings)
    }




    getCountUnconfirmedOrders() {
        let settings = {
            baseURL: `${this._httpService.baseUrl}/order-management/orders-unconfirmed-count`,
            method: 'GET'
        }
        console.info('orders-unconfirmed')
        return this._httpService.service(settings)
    }

    getCountOrdersStatus(status) {
        let settings = {
            baseURL: `${this._httpService.baseUrl}/order-management/orders-status-count?status=${status}`,
            method: 'GET'
        }
        console.info('orders-status-count')
        return this._httpService.service(settings)
    }

    sendFinishingEmail(orderId) {
        let settings = {
            baseURL: `${this._httpService.baseUrl}/order-management/orders/${orderId}/send-email`,
            method: 'GET'
        }
        console.info('sendFinishingEmail')
        return this._httpService.service(settings)
    }

    finishOrder(orderId) {
        let settings = {
            baseURL: `${this._httpService.baseUrl}/order-management/orders/${orderId}/finish`,
            method: 'GET'
        }
        console.info('finishOrder')
        return this._httpService.service(settings)
    }

    cancelOrder(orderId) {
        let settings = {
            baseURL: `${this._httpService.baseUrl}/order-management/orders/${orderId}/cancel`,
            method: 'GET'
        }
        console.info('cancelOrder')
        return this._httpService.service(settings)
    }

}

export default OrderService